export const formatPrice = (value, fuel = 'BENZINA') => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  const unit = fuel === 'METANO' ? '€/kg' : '€/l';
  return `${new Intl.NumberFormat('it-IT', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(Number(value))} ${unit}`;
};

export const formatNumber = (value) => new Intl.NumberFormat('it-IT').format(Number(value || 0));
export const formatDate = (value) => value ? new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: 'long', year: 'numeric' }).format(new Date(`${value}T12:00:00`)) : '—';
export const formatDateTime = (value) => value ? new Intl.DateTimeFormat('it-IT', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value.replace(' ', 'T'))) : '—';
export const signed = (value, digits = 3) => value === null || value === undefined ? '—' : `${Number(value) > 0 ? '+' : ''}${Number(value).toFixed(digits)}`;
